import { useNavigate, useParams } from "react-router-dom"
import { bandApi } from "../Api/api";
import { useEffect, useState } from "react";

const ConfirmDelete = () => {

    let { id } = useParams();

    const [band, setBand] = useState({});

    useEffect(() => {
        bandApi.getBandById(id)
            .then((res) => {
                setBand(res.data);
            })
            .catch(() => {
                setBand(null);
            })
    }, [])

    const navigate = useNavigate();

    const btnDa = async () => {

        try {
            await bandApi.deleteBand(id);
        } catch (error) {
            console.error('Error deleting trupa:', error);
        }

        navigate("/trupe")
    }

    const btnNu = () => {
        navigate("/trupe")
    }

    return (
        <div className="page-trupe resp">
            <h1 className="h1-confirm">Sigur doriti stergerea trupei {band.name}?</h1>
            <button onClick={btnDa} className="buton">DA</button>
            <button onClick={btnNu} className="buton">NU</button>
        </div>
    )
}

export default ConfirmDelete;